import React, { useEffect, useState } from "react";
import { Hide, Show } from "react-iconly";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./registerSecStep.scss";
import { getService, sendOtp } from "../../services/auth.service";
import { usersignup } from "../../services/auth.service";
import { toast } from "react-toastify";
import { ImageUpload, Trash } from "../../components/Icons";
import { FormGroup } from "react-bootstrap";
import Document from "../../assets/images/document.jpg";
import UserImg from "../../assets/images/user.jpg";
import SignUp from "../signUp/SignUp";
import { useDispatch } from "react-redux";
import { registerProvider } from "../../slice/registerSlice";
import { setLoader } from "../../slice/commonSlice";
import { roleSwich, checkDoucument } from "../../services/auth.service";
import { getContent, getAllContent } from "../../services/auth.service";
import MarketingEmailModal from "../marketingEmailModal/MarketingEmailModal";

const RegisterSecond = (props) => {
  const dispatch = useDispatch();
  const [showMarketingModal, setShowMarketingModal] = useState(false);

  const [step, setStep] = useState(1);
  const [image, setImage] = useState(null);
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);

  const [image3, setImage3] = useState(null);
  const [image4, setImage4] = useState(null);

  const [businessLicense, setbusinessLicense] = useState(null);
  const [passportOrLicense, setpassportOrLicense] = useState(null);
  const [input, setInput] = useState({});
  const [selectedOption, setSelectedOption] = useState();
  const [selectedOption1, setSelectedOption1] = useState();

  const [isChecked, setChecked] = useState(false);
  const [isCheckedInd, setCheckedInd] = useState(false);
  const [isMarketingSubChecked, setMarketingSubChecked] = useState(false);
  const [isMarketingSubCheckedInd, setMarketingSubCheckedInd] = useState(false);
  //   const [selectedOption, setSelectedOption] = useState();
  const [services, setServices] = useState([]);
  const [servicesInd, setServicesInd] = useState([]);

  const [inputs, setInputs] = useState({});
  const [activeTab, setActiveTab] = useState("tabcompany");
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(
      (prevShowConfirmPassword) => !prevShowConfirmPassword
    );
  };

  const [loading, setLoading] = useState(false);
  const [signUpModal, setSignUpModal] = useState(false);

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [errorsNext, setErrorsNext] = useState({
    signature: "",
    // businessLicense: '',
    passportOrLicense: "",
    contract: "",
    expertise: "",
    marketingEmail: "",
  });

  const [errorsNext1, setErrorsNext1] = useState({
    signatureind: "",
    // businessLicenseInd: '',
    passportOrLicenseInd: "",
    contract: "",
    expertiseInd: "",
    marketingEmail: "",
  });

  const [formData, setFormData] = useState({
    signature: "",
    businessLicense: "",
    passportOrLicense: "",
    businessLicenseInd: "",
    passportOrLicenseInd: "",
    signatureind: "",
    marketingEmail: "",
  });
  const [contentId, setContentId] = useState();
  const [content, setContent] = useState();
  const [showModal, setShowModal] = useState(false);

  const handleToggleModal = () => {
    setShowModal(!showModal);
  };
  //Selecting the file for individual functions

  const onFileChange1 = (e) => {
    setFormData((previous) => ({
      ...previous,
      businessLicense: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage1(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onFileChange5 = (e) => {
    setFormData((previous) => ({
      ...previous,
      profile: e.target.files[0],
    }));

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onFileChange2 = (e) => {
    setFormData((previous) => ({
      ...previous,
      passportOrLicense: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage2(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  //----------------------------------

  //Removing Images

  const handleRemoveImage = () => {
    setInput((prevData) => ({
      ...prevData,
      profilePic: "",
    }));
    setImage("");
  };

  const handleRemoveImage1 = () => {
    setInput((prevData) => ({
      ...prevData,
      businessLicense: "",
    }));
    // let errosInfo = {...errorsNext}
    // errosInfo.businessLicense = 'Business License is required.'
    // setErrorsNext(errosInfo);
    setImage1("");
    setFormData({
      ...formData,
      businessLicense: "",
    });
  };

  const handleRemoveImage2 = () => {
    setInput((prevData) => ({
      ...prevData,
      passportOrLicense: "",
    }));
    setImage2("");
    setFormData({
      ...formData,
      passportOrLicense: "",
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let res = await getService();
        setServices(res.data.services);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); // Add an empty dependency array if you want the effect to run once when the component mounts

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const redirect = () => {
    setSignUpModal(true);

    // props.setRegisterProviderModal(false)
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    // Convert camelCase to separate words
    const formattedFieldName = name
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());

    // Set error for the field only if it's empty onBlur
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "" ? `${formattedFieldName} is required` : "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDropdownChange = (event) => {
    const selectedOption = [{ id: event.target.value, value: "0" }];
    setSelectedOption(JSON.stringify(selectedOption));
  };

  const handleDropdownChange2 = (event) => {
    const selectedOption = [{ id: event.target.value, value: "0" }];
    setSelectedOption1(JSON.stringify(selectedOption));
  };
  const handleCheckboxClick = () => {
    // Toggle the state when the checkbox is clicked
    setChecked(!isChecked);
  };
  const handleCheckboxClickInd = () => {
    // Toggle the state when the checkbox is clicked
    setCheckedInd(!isCheckedInd);
  };

  const handleMarketingSubCheckboxClick = () => {
    // Toggle the state when the checkbox is clicked
    setMarketingSubChecked(!isMarketingSubChecked);
  };
  // const handleMarketingSubCheckboxClickInd = () => {
  //   // Toggle the state when the checkbox is clicked
  //   setMarketingSubCheckedInd(!isMarketingSubCheckedInd);
  // };

  const handleMarketingEmail = () => {
    formData.marketingEmail = "";
    errorsNext.marketingEmail = "";
    errorsNext1.marketingEmail = "";
    setShowMarketingModal(true);
  };

  const checkRequiredFields = () => {
    if (activeTab === "tabcompany") {
      if (
        !selectedOption ||
        formData.passportOrLicense == "" ||
        formData.signature == "" ||
        !isChecked
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        !selectedOption1 ||
        formData.passportOrLicenseInd === "" ||
        formData.signatureind == "" ||
        !isCheckedInd
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  const handleMarketingModal = () => {
    setShowMarketingModal(false);
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (activeTab == "tabcompany") {
      if (!validateForm()) {
        return;
      }
    } else {
      if (!validateForm1()) {
        return;
      }
    }
    await dispatch(setLoader(true));
    const formDatas = new FormData();
    formDatas.append("userType", "provider");
    if (activeTab == "tabcompany") {
      formDatas.append("businessLicense", formData.businessLicense);
      formDatas.append("passportOrLicense", formData.passportOrLicense);
      formDatas.append("signature", formData.signature);
      formDatas.append("services", selectedOption);
      formDatas.append("for", "company");
      formDatas.append("currentUserType", "user");
      if (showMarketingModal && formData.marketingEmail) {
        formDatas.append("marketingEmail", formData.marketingEmail);
      }
    } else {
      formDatas.append("businessLicense", formData.businessLicenseInd);
      formDatas.append("passportOrLicense", formData.passportOrLicenseInd);
      formDatas.append("signature", formData.signatureind);
      formDatas.append("services", selectedOption1);
      formDatas.append("for", "individual");
      formDatas.append("currentUserType", "user");
      if (showMarketingModal && formData.marketingEmail) {
        formDatas.append("marketingEmail", formData.marketingEmail);
      }
    }
    try {
      // await dispatch(setLoader(true));

      const result = await roleSwich(formDatas);
      const response = await checkDoucument();
      if (response?.data?.documentSubmitted == true) {
        props.setOpenProvidrRegSecModal(false);
        showMarketingModal(false);
      }
      showMarketingModal(false);
      await dispatch(setLoader(false));
    } catch (e) {
      await dispatch(setLoader(false));
    } finally {
      await dispatch(setLoader(false));
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errorsNext };
    if (!formData.signature) {
      newErrors.signature =
        "Signature is required and signature should be your first name";
      isValid = false;
    } else {
      newErrors.signature = "";
    }

    // if (!formData.businessLicense) {
    //   newErrors.businessLicense = 'Business License is required.';
    //   isValid = false;
    // } else {
    //   newErrors.businessLicense = '';
    // }
    if (!selectedOption) {
      newErrors.expertise = "Please select your expertise.";
      isValid = false;
    } else {
      newErrors.expertise = "";
    }
    if (!formData.passportOrLicense) {
      newErrors.passportOrLicense = "Passport or Drivers License is required.";
      isValid = false;
    } else {
      newErrors.passportOrLicense = "";
    }

    if (showMarketingModal && !isMarketingSubChecked) {
      if (showMarketingModal && formData?.marketingEmail === "") {
        newErrors.marketingEmail = "Marketing email is required.";
        isValid = false;
      } else if (
        showMarketingModal &&
        formData?.marketingEmail !== "" &&
        !/^\S+@\S+\.\S+$/.test(formData.marketingEmail.trim())
      ) {
        {
          newErrors.marketingEmail = "Invalid email address.";
          isValid = false;
        }
      } else {
        newErrors.marketingEmail = "";
      }
    }

    if (
      showMarketingModal &&
      formData?.marketingEmail &&
      !/^\S+@\S+\.\S+$/.test(formData.marketingEmail.trim())
    ) {
      newErrors.marketingEmail = "Invalid Email Address.";
      isValid = false;
    } else {
      newErrors.marketingEmail = "";
    }

    if (!isChecked) {
      newErrors.contract = "You must agree to the Contract waiver.";
      isValid = false;
    } else {
      newErrors.contract = "";
    }
    setErrorsNext(newErrors);

    return isValid;
  };

  const validateForm1 = () => {
    let isValid = true;
    const newErrors = { ...errorsNext1 };
    if (!formData.signatureind) {
      newErrors.signatureind =
        "Signature is required and signature should be your first name";
      isValid = false;
    } else {
      newErrors.signatureind = "";
    }

    if (!selectedOption1) {
      newErrors.expertiseInd = "Please select your expertise.";
      isValid = false;
    } else {
      newErrors.expertiseInd = "";
    }

    if (showMarketingModal && formData?.marketingEmail === "") {
      newErrors.marketingEmail = "Marketing email is required.";
      isValid = false;
    } else {
      newErrors.marketingEmail = "";
    }

    if (showMarketingModal && !isMarketingSubChecked) {
      if (showMarketingModal && formData?.marketingEmail === "") {
        newErrors.marketingEmail = "Marketing email is required.";
        isValid = false;
      } else if (
        showMarketingModal &&
        formData?.marketingEmail !== "" &&
        !/^\S+@\S+\.\S+$/.test(formData.marketingEmail.trim())
      ) {
        {
          newErrors.marketingEmail = "Invalid email address.";
          isValid = false;
        }
      } else {
        newErrors.marketingEmail = "";
      }
    }
    // if (!formData.businessLicenseInd) {
    //   newErrors.businessLicenseInd = 'Business License is required.';
    //   isValid = false;
    // } else {
    //   newErrors.businessLicenseInd = '';
    // }

    if (!formData.passportOrLicenseInd) {
      newErrors.passportOrLicenseInd = "Proof of eligibility is required";
      isValid = false;
    } else {
      newErrors.passportOrLicenseInd = "";
    }

    if (!isCheckedInd) {
      newErrors.contract = "You must agree to the Contract waiver.";
      isValid = false;
    } else {
      newErrors.contract = "";
    }
    setErrorsNext1(newErrors);

    return isValid;
  };

  const onFileChange3 = (e) => {
    setFormData((previous) => ({
      ...previous,
      businessLicenseInd: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage3(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onFileChange4 = (e) => {
    setFormData((previous) => ({
      ...previous,
      passportOrLicenseInd: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage4(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const onHide = () => {
    props.setOpenProvidrRegSecModal(false);
    localStorage.removeItem("facebookData");
    localStorage.removeItem("userData");
  };

  const getallcontent = async () => {
    const result = await getAllContent();
    const searchObject = result.data.find(
      (data) => data.slug == "contractwaiver"
    );
    setContentId(searchObject._id);
  };

  const getcontent = async () => {
    const paylaod = { _id: contentId };
    const result = await getContent(paylaod);
    setContent(result.data.content);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let res = await getService();
        setServices(res.data.services);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    getallcontent();
  }, []); // Add an empty dependency array if you want the effect to run once when the component mounts

  useEffect(() => {
    getcontent();
  }, [contentId]);

  return (
    <>
      <Modal size="lg" show={showModal} centered onHide={handleToggleModal}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        show={props.openProviderRegSecModal}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <div className="modal-sub-title">Please submit your document</div>
          {loading && (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          )}

          <Form className="modal-form-wrapper">
            <div className="chosse-account">
              <ul>
                <li
                  onClick={() => handleTabClick("tabcompany")}
                  className={activeTab === "tabcompany" ? "active" : ""}
                >
                  For Company
                </li>
                <li>
                  <div className="divider-line"></div>
                </li>
                <li
                  onClick={() => handleTabClick("tabindividual")}
                  className={activeTab === "tabindividual" ? "active" : ""}
                >
                  For Individual
                </li>
              </ul>
            </div>
            {activeTab === "tabcompany" && (
              <>
                <div className="tab-wrapper">
                  <FormGroup className="mb-3 ">
                    <div className="file-upload-wrapper">
                      {image1 ? (
                        <div className="document-proof-wrapper">
                          <div className="doc-img">
                            <img src={image1} alt="Document" />
                          </div>
                          {/* <div className='doc-name text-truncate'>
                            Document name
                          </div> */}
                          <div
                            className="trash-icon"
                            onClick={handleRemoveImage1}
                          >
                            <Trash />
                          </div>
                        </div>
                      ) : (
                        <label htmlFor="businessLicense">
                          <ImageUpload />
                          <span>
                            Add Business License and Certificate of
                            Incorporation (If applicable)
                          </span>
                          <input
                            id="businessLicense"
                            type="file"
                            onChange={onFileChange1}
                          />
                        </label>
                      )}
                    </div>
                    {/* {errorsNext.businessLicense && <span style={{ color: 'red' }}>{errorsNext.businessLicense}</span>} */}
                  </FormGroup>
                  <FormGroup className="mb-3 ">
                    <div className="file-upload-wrapper">
                      {image2 ? (
                        <div className="document-proof-wrapper">
                          <div className="doc-img">
                            <img src={image2} alt="Document" />
                          </div>
                          {/* <div className='doc-name text-truncate'>
                            Document name
                          </div> */}
                          <div
                            className="trash-icon"
                            onClick={handleRemoveImage2}
                          >
                            <Trash />
                          </div>
                        </div>
                      ) : (
                        <label htmlFor="passportOrLicense">
                          <ImageUpload />
                          <span>
                            Passport Or Drivers License
                            <span className="req-field">*</span>
                          </span>
                          <input
                            id="passportOrLicense"
                            type="file"
                            onChange={onFileChange2}
                          />
                        </label>
                      )}
                    </div>
                    {errorsNext.passportOrLicense && (
                      <span style={{ color: "red" }}>
                        {errorsNext.passportOrLicense}
                      </span>
                    )}
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Form.Label>
                      Electronic expertise<span className="req-field">*</span>
                    </Form.Label>
                    <Form.Select
                      aria-label="Select your expertise or the services"
                      onChange={handleDropdownChange}
                    >
                      <option value="">
                        Select your primary expertise or service
                      </option>
                      {services.map((service) => (
                        <option key={service._id} value={service._id}>
                          {service.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errorsNext.expertise && (
                      <div style={{ color: "red", marginTop: "0.5rem" }}>
                        {errorsNext.expertise}
                      </div>
                    )}
                  </FormGroup>

                  <Form.Group className="mb-3" controlId="firstname">
                    <Form.Label>
                      Electronic signature<span className="req-field">*</span>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="signature"
                      onChange={handleInputChange}
                      placeholder="Enter Your name for Electronic signature"
                    />
                    {errorsNext.signature && (
                      <span style={{ color: "red" }}>
                        {errorsNext.signature}
                      </span>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-4" controlId="termsCondition">
                    <div className="d-flex w-100 align-items-center gap-2 form-check-wrapper">
                      <Form.Check
                        className="mb-0"
                        type="checkbox"
                        id="contract"
                        checked={isChecked}
                        onClick={handleCheckboxClick}
                      />
                      <div>
                        I agree with the{" "}
                        <span onClick={handleToggleModal}>
                          {" "}
                          Contract waiver
                        </span>
                        <br />
                        Confirm contract has been read and accepted
                      </div>
                    </div>
                    {errorsNext.contract && (
                      <span style={{ color: "red" }}>
                        {errorsNext.contract}
                      </span>
                    )}
                  </Form.Group>
                  {/* <div className="d-flex w-100 align-items-center gap-2 form-check-wrapper mb-3">
                    <Form.Check
                      className="mb-0"
                      type="checkbox"
                      id="marketingSubCompany"
                      checked={isMarketingSubChecked}
                      onClick={handleMarketingSubCheckboxClick}
                    />
                    <div>
                      Opt for Marketing Email Subscription{" "}
                      <span onClick={handleMarketingEmail}>Learn More</span>
                    </div>
                  </div>
                  {isMarketingSubChecked && (
                    <Form.Group className="mb-3 mt-3" controlId="phoneNumber">
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="marketingEmail"
                        value={formData.marketingEmail}
                        onBlur={handleBlur}
                        onChange={handleInputChange}
                        placeholder="Enter your marketing email"
                      />
                      <span style={{ color: "red" }}>
                        {errors.marketingEmail}
                      </span>
                    </Form.Group>
                  )} */}
                </div>
              </>
            )}
            {activeTab === "tabindividual" && (
              <>
                <div className="tab-wrapper">
                  <FormGroup className="mb-3 ">
                    <div className="file-upload-wrapper">
                      {image3 ? (
                        <div className="document-proof-wrapper">
                          <div className="doc-img">
                            <img src={image3} alt="Document" />
                          </div>
                          {/* <div className='doc-name text-truncate'>
                            Document name
                          </div> */}
                          <div className="trash-icon">
                            <Trash />
                          </div>
                        </div>
                      ) : (
                        <label htmlFor="businessLicenseInd">
                          <ImageUpload />
                          <span>
                            Add Business License and Certificate of
                            Incorporation (If applicable)
                          </span>
                          <input
                            id="businessLicenseInd"
                            type="file"
                            onChange={onFileChange3}
                          />
                        </label>
                      )}
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-3 ">
                    <div className="file-upload-wrapper">
                      {image4 ? (
                        <div className="document-proof-wrapper">
                          <div className="doc-img">
                            <img src={image4} alt="Document" />
                          </div>
                          {/* <div className='doc-name text-truncate'>
                            Document name
                          </div> */}
                          <div className="trash-icon">
                            <Trash />
                          </div>
                        </div>
                      ) : (
                        <label htmlFor="passportOrLicenseInd">
                          <ImageUpload />
                          <span>
                            Upload Passport or Drivers License
                            <span className="req-field">*</span>
                          </span>
                          <input
                            id="passportOrLicenseInd"
                            type="file"
                            onChange={onFileChange4}
                          />
                        </label>
                      )}
                    </div>
                    {errorsNext1.passportOrLicenseInd && (
                      <span style={{ color: "red" }}>
                        {errorsNext1.passportOrLicenseInd}
                      </span>
                    )}
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Form.Label>
                      Electronic expertise<span className="req-field">*</span>
                    </Form.Label>

                    <Form.Select
                      aria-label="Select your expertise or the services"
                      onChange={handleDropdownChange2}
                    >
                      <option value="">
                        Select your primary expertise or service
                      </option>
                      {services.map((service) => (
                        <option key={service._id} value={service._id}>
                          {service.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errorsNext1.expertiseInd && (
                      <div style={{ color: "red", marginTop: "0.5rem" }}>
                        {errorsNext1.expertiseInd}
                      </div>
                    )}
                  </FormGroup>

                  <Form.Group className="mb-3" controlId="firstname">
                    <Form.Label>
                      Electronic signature<span className="req-field">*</span>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="signatureind"
                      id="signatureind"
                      onChange={handleInputChange}
                      placeholder="Enter Your name for Electronic signature"
                    />
                    {errorsNext1.signatureind && (
                      <span style={{ color: "red" }}>
                        {errorsNext1.signatureind}
                      </span>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-4" controlId="termsCondition">
                    <div className="d-flex w-100 align-items-center gap-2 form-check-wrapper">
                      <Form.Check
                        className="mb-0"
                        type="checkbox"
                        id="contractInd"
                        checked={isCheckedInd}
                        onClick={handleCheckboxClickInd}
                      />
                      <div>
                        I agree with the{" "}
                        <span onClick={handleToggleModal}>
                          {" "}
                          Contract waiver
                        </span>
                        <br />
                        Confirm contract has been read and accepted
                      </div>
                    </div>
                    {errorsNext1.contract && (
                      <span style={{ color: "red" }}>
                        {errorsNext1.contract}
                      </span>
                    )}
                  </Form.Group>
                  {/* <div className="d-flex w-100 align-items-center gap-2 form-check-wrapper mb-3">
                    <Form.Check
                      className="mb-0"
                      type="checkbox"
                      id="marketingSubInd"
                      checked={isMarketingSubCheckedInd}
                      onClick={handleMarketingSubCheckboxClickInd}
                    />
                    <div>
                      Opt for Marketing Email Subscription{" "}
                      <span onClick={handleMarketingEmail}>Learn More</span>
                    </div>
                  </div>
                  {isMarketingSubCheckedInd && (
                    <Form.Group className="mb-3 mt-3" controlId="phoneNumber">
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="marketingEmail"
                        value={formData.marketingEmail}
                        onBlur={handleBlur}
                        onChange={handleInputChange}
                        placeholder="Enter your marketing email"
                      />
                      <span style={{ color: "red" }}>
                        {errors.marketingEmailInd}
                      </span>
                    </Form.Group>
                  )} */}
                </div>
              </>
            )}
            <Form.Group className="mb-4">
              <div className="d-grid">
                <Button
                  type="submit"
                  onClick={handleSignUp}
                  variant="primary"
                  size="lg"
                >
                  Submit
                </Button>
              </div>
            </Form.Group>
            {/* )} */}
          </Form>

          <>
            <div className="divider mb-4">
              {" "}
              <span>Or</span>
            </div>
            <div className="mb-4 mt-2" style={{ padding: "0px 29px" }}>
              <div className="d-grid">
                <Button
                  // type="submit"
                  onClick={handleMarketingEmail}
                  variant="primary"
                  size="lg"
                  disabled={checkRequiredFields()}
                >
                  Marketing Provider Sign Up
                </Button>
              </div>
            </div>
          </>
        </Modal.Body>
      </Modal>
      {showMarketingModal ? (
        <MarketingEmailModal
          showMarketingModal={showMarketingModal}
          handleMarketingModal={handleMarketingModal}
          formDataMarketingEmail={formData.marketingEmail}
          handleBlur={handleBlur}
          handleInputChange={handleInputChange}
          marketingEmailError={
            activeTab === "tabcompany"
              ? errorsNext.marketingEmail
              : errorsNext1.marketingEmail
          }
          activeTab={activeTab}
          handleSignupCompany={handleSignUp}
          handleSignupIndividual={handleSignUp}
          isMarketingSubChecked={isMarketingSubChecked}
          setMarketingSubChecked={setMarketingSubChecked}
          handleMarketingSubCheckboxClick={handleMarketingSubCheckboxClick}
        />
      ) : null}
    </>
  );
};

export default RegisterSecond;
